import { Container, Modal, Segment } from 'semantic-ui-react'
import { Logo, ProgressBar } from '../atoms'
import { MarkupText } from 'preact-i18n'
import { useStore } from '../../store/useStore'

const LoadingModal = () => {
  const store = useStore()
  return (
    <Modal id="loading-modal" basic open={!store.initialOptionsStore.isConfigured.value}>
      <Modal.Content>
        <Container text textAlign="center">
          <Segment inverted style={{ background: 'transparent' }}>
            <Logo animated={false} />
          </Segment>
          <ProgressBar
            label={
              <span style={{ fontSize: '.85rem' }}>
                {' '}
                <MarkupText id="info.loading" />
              </span>
            }
            value={store.loadingStore.percentage.value}
            max={100}
          />
        </Container>
      </Modal.Content>
    </Modal>
  )
}
export default LoadingModal
